import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isEven, isNullOrUndefinedOrEmpty } from "base/utils";
import FormTextArea from "base/FormTextArea";
import FormTextField from "base/FormTextField";
import React, { useEffect, useState } from "react";

const AddInstruction = ({ index, instruction, onAdd, onRemove }) => {
  const [detail, setDetail] = useState("");
  const [time, setTime] = useState(0);
  const removeInstruction = () => {
    onRemove();
  };

  const handleInstructionUpdate = (val) => {
    setDetail(val);
  };

  const handleTimeUpdate = (val) => {
    setTime(val);
  };

  useEffect(() => {
    if (!isNullOrUndefinedOrEmpty(detail)) {
      onAdd({
        id: instruction.id,
        detail: detail,
        minutes_to_complete: time,
        sort_order: index + 1,
      });
    }
  }, [detail, time]);

  return (
    <div
      className={`Column my-4 p-10  ${isEven(index) ? "even" : "odd"}`}
      key={instruction.id}
    >
      <div className="Row">
        <FormTextArea
          formLabel="Recipe Instruction"
          minRows={3}
          onChange={handleInstructionUpdate}
          placeholder={`Enter ${
            index == 0 ? "first" : "next"
          } recipe instruction`}
          required
          textAreaClasses="Transparent"
          variant="outlined"
        />
        <button className="Delete-Icon" onClick={removeInstruction}>
          <FontAwesomeIcon icon={faTrashCan} />
        </button>
      </div>
      {/* <FormTextField
        fieldLabel="Minutes to complete"
        fieldType="number"
        onBlur={handleTimeUpdate}
        placeholder="How many minutes will this step take to complete?"
      /> */}
    </div>
  );
};

export default AddInstruction;
